/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AccountingAccountCostCenter, BuilderPermission } from '@gh/builder-shared-data';
import { PlainImmutablePageState, setEntityField, UserContext } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { omit } from 'lodash';
import {
  AccountingAccount,
  accountingAccountArr,
  getAccountingAccountId,
  SystemVarsAccountingExpenseModel,
} from '../../../resources';

@Injectable()
export class SystemVarsAccountingExpenseFormState extends PlainImmutablePageState<SystemVarsAccountingExpenseModel> {
  jobExpenseAccounts$ = this.select(({ jobExpenseAccounts }) => jobExpenseAccounts);

  constructor(private userContext: UserContext) {
    super({ jobExpenseAccounts: [] }, FormMode.EditMode);
  }

  build(details: SystemVarsAccountingExpenseModel): void {
    this.setValue(details);
    this.setMode(this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Accounting.EDIT)
      ? FormMode.EditMode
      : FormMode.ViewMode,
    );
    this.resetDirty();
  }

  deleteRecord(record: AccountingAccount): void {
    this.startChangeDetection();
    this.setField(
      'jobExpenseAccounts',
      accountingAccountArr.remove(this.value.jobExpenseAccounts, getAccountingAccountId(record)),
    );
    this.setDirtyIfChanged();
  }

  addRecords(records: AccountingAccount[]): void {
    this.startChangeDetection();
    this.setField('jobExpenseAccounts', accountingAccountArr.append(this.value.jobExpenseAccounts, ...records));
    this.setDirtyIfChanged();
  }

  updateCostCenter(record: AccountingAccount, costCenter: AccountingAccountCostCenter): void {
    this.startChangeDetection();

    this.setField(
      'jobExpenseAccounts',
      accountingAccountArr.update(
        this.value.jobExpenseAccounts,
        getAccountingAccountId(record),
        (account) => setEntityField(account, 'costCenter', <AccountingAccountCostCenter>omit(costCenter, 'display')),
      ),
    );

    this.setDirtyIfChanged();
  }
}
